import { z } from 'zod'

// API Base URL
const API_BASE_URL = 'https://sui-explorer-api-staging.space-and-time.workers.dev/api'
// const API_BASE_URL = "http://localhost:8787/api"


// API Error Schema
export const ApiErrorSchema = z.object({
  code: z.string(),
  message: z.string(),
  details: z.any().optional(),
})
export type ApiError = z.infer<typeof ApiErrorSchema>

// API Client Class
export class ApiClient {
  private baseUrl: string
	private network: string;

  constructor(baseUrl: string = API_BASE_URL, network: "mainnet" | "testnet" = "mainnet" ) {
    this.baseUrl = baseUrl;
		this.network = network;
  }

  private async request<T>(
    endpoint: string,
    options: RequestInit = {}
  ): Promise<T> {
    try {
      const response = await fetch(`${this.baseUrl}${endpoint}`, {
        ...options,
        headers: {
          'Content-Type': 'application/json',
          ...options.headers,
					'X-Sui-Network': this.network
        },
      })

      const data = await response.json()

      if (!response.ok) {
        const error = ApiErrorSchema.parse(data)
        throw new Error(error.message)
      }

      return data as T
    } catch (error) {
      if (error instanceof Error) {
        throw error
      }
      throw new Error('An unknown error occurred')
    }
  }

	// Network
	async getNetworkStats(): Promise<any> {
    const data = await this.request<any>('/walrus/v1/network/stats')
    return data;
  }
	
	async getNetworkBlobSizeDistribution(): Promise<any> {
    const data = await this.request<any>('/walrus/v1/network/blob-size-distribution')
    return data;
  }

	async getNetworkDataGrowthRate(): Promise<any> {
    const data = await this.request<any>('/walrus/v1/network/data-growth-rate');
    return data;
  }

	async getNetworkBlobGrowthRate(): Promise<any> { 
		const data = await this.request<any>('/walrus/v1/network/blob-growth-rate');
		return data;
	}


	// Operators
	async getOperators(): Promise<any> {
		const data = await this.request<any>('/walrus/v1/operators');
		return data;
	}

	// Blobs
	async getBlobs(limit?: number, txDigest?: string, eventSeq?: string): Promise<any> {
		let url = `/walrus/v1/blobs`;
		if (limit || txDigest || eventSeq) url = url + '?';
		url = url + `${limit ? `limit=${limit}&` : ''}` + `${txDigest ? `txDigest=${txDigest}&` : ''}` + `${eventSeq ? `eventSeq=${eventSeq}` : ''}`;
		const data = await this.request<any>(url)
    return data
	}

	async getBlob(id: string): Promise<any> {
		let url = `/walrus/v1/blobs/${id}`
		const data = await this.request<any>(url);
		return data;
	}

	async getBlobVersions(id: string): Promise<any> {
		let url = `/walrus/v1/blobs/${id}/versions`
		const data = await this.request<any>(url);
		return data;
	}


	// Events
	async getEvents(limit?: number, txDigest?: string, eventSeq?: string): Promise<any> {
		let url = `/walrus/v1/events`;
		if (limit || txDigest || eventSeq) url = url + '?';
		url = url + `${limit ? `limit=${limit}&` : ''}` + `${txDigest ? `txDigest=${txDigest}&` : ''}` + `${eventSeq ? `eventSeq=${eventSeq}` : ''}`;
		const data = await this.request<any>(url)
    return data
	}

	// Search
	async getSearch(id: string): Promise<any> {
		let url = `/walrus/v1/search?id=${id}`;
		const data = await this.request<any>(url)
    return data
	}

}